import { createNextTableContext } from '@core/table';

export const ProductTypesTableContext = createNextTableContext();
